module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Frontbmatterbheads"
  }, [_vm._v("Flowers")]), _vm._v(" "), _c('p', {
    staticClass: "P_Chapterbintrobtext"
  }, [_vm._v("Flowers are probably the most popular choice of all cake decorations. There are many books written on the art of sugar flower making. This taster from "), _c('em', [_vm._v("The Contemporary Cake Decorating Bible")]), _vm._v(" touches on this subject here. The simplest representation of a flower is a cut-out shape. Other more interesting ways of representing flowers are to create fabric-effect flowers out of paste or try your hand at creating lifelike flowers.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fd1cca6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm.vue
// module id = 57
// module chunks = 0